import { Typography } from "@mui/material";
import { TypographyProps } from "../types/prop-types";

const SubTitle = ({ sx, center, children, color = "" }: TypographyProps) => (
  <Typography
    variant="h5"
    sx={{ ...sx, mb: "1%", textAlign: center ? "center" : "unset" }}
    color={color}
  >
    {children}
  </Typography>
);
export default SubTitle;
